var map = {
	"./CB0000_rabbit.png": "f053",
	"./CB0000_rabbit_stroke.png": "736a",
	"./CB0010_bear.png": "7878",
	"./CB0010_bear_stroke.png": "bba8",
	"./CB0020_cat.png": "dc85",
	"./CB0020_cat_stroke.png": "0c5d",
	"./CB0030_hamster.png": "ecdf",
	"./CB0030_hamster_stroke.png": "50ef",
	"./CC0000_default.png": "d200",
	"./CE0000_default.png": "7d30",
	"./CE0000_default_F1.png": "0eff",
	"./CH0000_default.png": "991a",
	"./CM0000_rabbit.png": "e37b",
	"./CM0010_bear.png": "f2d1",
	"./CM0020_cat.png": "d998",
	"./CM0030_hamster.png": "549a",
	"./CS0000_default.png": "1e77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a35b";